import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "meeting-link-popup" }
const _hoisted_2 = { class: "link-header" }
const _hoisted_3 = { class: "active-indicator" }
const _hoisted_4 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
  fill: "#e23d35"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "off"
}
const _hoisted_8 = { class: "invite-header" }
const _hoisted_9 = {
  key: 0,
  class: "invite-name"
}
const _hoisted_10 = {
  key: 1,
  class: "invite-name"
}
const _hoisted_11 = {
  key: 2,
  class: "invite-description"
}
const _hoisted_12 = {
  key: 3,
  class: "invite-description"
}
const _hoisted_13 = {
  key: 4,
  class: "invite-description"
}
const _hoisted_14 = {
  key: 5,
  class: "invite-description"
}
const _hoisted_15 = {
  key: 6,
  class: "invite-description"
}
const _hoisted_16 = { class: "popup-content" }
const _hoisted_17 = { class: "info-header" }
const _hoisted_18 = { class: "dialogue" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
      fill: "#e23d35"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_22 = { class: "meeting-note text-block" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Meeting Note", -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "description"
}
const _hoisted_25 = {
  key: 1,
  class: "description"
}
const _hoisted_26 = { class: "meeting-location text-block" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Location Details", -1 /* HOISTED */)
const _hoisted_28 = {
  key: 0,
  class: "description"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Video Link: ")
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 1,
  class: "description"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Phone Number: ")
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 2,
  class: "description"
}
const _hoisted_35 = { class: "line" }
const _hoisted_36 = {
  key: 0,
  class: "line"
}
const _hoisted_37 = { class: "line" }
const _hoisted_38 = {
  key: 3,
  class: "description"
}
const _hoisted_39 = {
  key: 4,
  class: "description"
}
const _hoisted_40 = { class: "meeting-contact text-block" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Contact Details Shared", -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "description"
}
const _hoisted_43 = {
  key: 1,
  class: "description"
}
const _hoisted_44 = {
  key: 0,
  class: "button-container"
}
const _hoisted_45 = {
  key: 1,
  class: "button-container"
}
const _hoisted_46 = { class: "manage" }
const _hoisted_47 = {
  key: 0,
  class: "manage-popup"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.90922 0.000179007C1.7464 0.000179007 1.58339 0.0622029 1.4593 0.186609L0.186609 1.4593C-0.062203 1.70812 -0.062203 2.11096 0.186609 2.35914L4.82747 7L0.186609 11.6409C-0.062203 11.8897 -0.062203 12.2925 0.186609 12.5407L1.4593 13.8134C1.70812 14.0622 2.11096 14.0622 2.35914 13.8134L7 9.17253L11.6409 13.8134C11.889 14.0622 12.2925 14.0622 12.5407 13.8134L13.8134 12.5407C14.0622 12.2919 14.0622 11.889 13.8134 11.6409L9.17253 7L13.8134 2.35914C14.0622 2.11096 14.0622 1.70748 13.8134 1.4593L12.5407 0.186609C12.2919 -0.062203 11.889 -0.062203 11.6409 0.186609L7 4.82747L2.35914 0.186609C2.23473 0.0622029 2.07205 0.000179007 1.90922 0.000179007Z",
    fill: "black"
  })
], -1 /* HOISTED */)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "manage" }
const _hoisted_51 = {
  key: 0,
  class: "manage-popup"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Turn Link Off")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Turn Link On")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.90922 0.000179007C1.7464 0.000179007 1.58339 0.0622029 1.4593 0.186609L0.186609 1.4593C-0.062203 1.70812 -0.062203 2.11096 0.186609 2.35914L4.82747 7L0.186609 11.6409C-0.062203 11.8897 -0.062203 12.2925 0.186609 12.5407L1.4593 13.8134C1.70812 14.0622 2.11096 14.0622 2.35914 13.8134L7 9.17253L11.6409 13.8134C11.889 14.0622 12.2925 14.0622 12.5407 13.8134L13.8134 12.5407C14.0622 12.2919 14.0622 11.889 13.8134 11.6409L9.17253 7L13.8134 2.35914C14.0622 2.11096 14.0622 1.70748 13.8134 1.4593L12.5407 0.186609C12.2919 -0.062203 11.889 -0.062203 11.6409 0.186609L7 4.82747L2.35914 0.186609C2.23473 0.0622029 2.07205 0.000179007 1.90922 0.000179007Z",
    fill: "black"
  })
], -1 /* HOISTED */)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["CloseButton"], { onClickedClose: $setup.closePopup }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($setup.linkActive)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, "OFF"))
      ]),
      _createElementVNode("div", _hoisted_8, [
        ($setup.editLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tmpName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.tmpName]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($props.selectedLink.name), 1 /* TEXT */)),
        ($props.selectedLink?.location?.type == 'video')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Video Call"))
          : ($props.selectedLink?.location?.type == 'phone')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Phone Call"))
            : ($props.selectedLink?.location?.type == 'physical')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "In Person in " + _toDisplayString($props.selectedLink.location.fields.city) + ", " + _toDisplayString($props.selectedLink.location.fields.state), 1 /* TEXT */))
              : ($props.selectedLink?.location?.type == 'other')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Details Provided"))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, "No Location information provided"))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString($props.selectedLink.price.currency) + _toDisplayString($props.selectedLink.price.amount), 1 /* TEXT */),
            _hoisted_20,
            _createElementVNode("span", null, _toDisplayString($props.selectedLink.minutes) + " mins", 1 /* TEXT */)
          ]),
          _hoisted_21
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        ($setup.editLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.tmpNote) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.tmpNote]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($props.selectedLink.note), 1 /* TEXT */))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        ($props.selectedLink?.location?.type == 'video')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("a", {
                href: $props.selectedLink.location.fields.link,
                target: "_blank"
              }, _toDisplayString($props.selectedLink.location.fields.link), 9 /* TEXT, PROPS */, _hoisted_30)
            ]))
          : ($props.selectedLink?.location?.type == 'phone')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("a", {
                  href: 'tel:'+$props.selectedLink.location.fields.number,
                  target: "_blank"
                }, _toDisplayString($props.selectedLink.location.fields.number), 9 /* TEXT, PROPS */, _hoisted_33)
              ]))
            : ($props.selectedLink?.location?.type == 'physical')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString($props.selectedLink.location.fields.street1), 1 /* TEXT */),
                  ($props.selectedLink.location.fields.street2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($props.selectedLink.location.fields.street2), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_37, _toDisplayString($props.selectedLink.location.fields.city) + ", " + _toDisplayString($props.selectedLink.location.fields.state) + " " + _toDisplayString($props.selectedLink.location.fields.postal), 1 /* TEXT */)
                ]))
              : ($props.selectedLink?.location?.type == 'other')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($props.selectedLink.location.fields.note), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_39, "No Location information provided"))
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        ($setup.editLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.tmpContact) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.tmpContact]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString($props.selectedLink.contactInfo), 1 /* TEXT */))
      ])
    ]),
    ($setup.editLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("button", {
            class: "primary",
            onClick: $setup.handleSave
          }, "Save"),
          _createElementVNode("button", {
            class: "outline",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.editLink=false))
          }, "Cancel")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => {$setup.manage = false; $setup.share = true})
            }, "Share"),
            ($setup.share)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  ($setup.inviteLink)
                    ? (_openBlock(), _createBlock($setup["VQrCode"], {
                        key: 0,
                        class: "qr-code",
                        message: $setup.inviteLink
                      }, null, 8 /* PROPS */, ["message"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {$setup.handleCopy(); $setup.share = false})
                  }, "Copy Link"),
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {$setup.handlePreview();$setup.share = false})
                  }, "Preview Link"),
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {$setup.handleEmbed(); $setup.share = false})
                  }, "Copy Embed Code"),
                  _createElementVNode("div", {
                    class: "close-button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.share = false))
                  }, _hoisted_49)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              class: "outline",
              onClick: _cache[9] || (_cache[9] = ($event: any) => {$setup.share = false; $setup.manage = true})
            }, "Manage"),
            ($setup.manage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {$setup.handleEdit(); $setup.manage = false})
                  }, "Edit"),
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {$setup.handleToggle(); $setup.manage = false})
                  }, [
                    ($setup.linkActive)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_52
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_53
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _createElementVNode("button", {
                    class: "outline",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {$setup.handleDelete(); $setup.manage = false})
                  }, "Delete"),
                  _createElementVNode("div", {
                    class: "close-button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.manage = false))
                  }, _hoisted_55)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}